import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]

import { computed } from 'vue';
import {
  startOfMonth,
  endOfMonth,
  addDays,
  format,
  isValid,
  parseISO
} from 'date-fns';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarYear',
  props: {
    baseDate: {},
    events: {},
    moduleName: {},
    title: {},
    onCreate: { type: Function },
    calendarConfig: {}
  },
  setup(__props: any) {

const props = __props;

const currentYear = computed(() => props.baseDate.getFullYear());

const monthLabels = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

function normalizeDateInput(input: any): string | null {
  if (!input) return null;
  const dateObj = typeof input === 'string' ? parseISO(input) : input;
  if (!isValid(dateObj)) return null;
  return format(dateObj, 'yyyy-MM-dd');
}

function getEventsForDate(dateStr: string) {
  const field = props.calendarConfig?.dateField || 'date';
  return props.events
    .filter(e => normalizeDateInput(e.original?.[field]) === dateStr)
    .sort((a, b) => new Date(a.original?.[field]).getTime() - new Date(b.original?.[field]).getTime());
}

function getDaysForMonth(month: number) {
  const start = startOfMonth(new Date(currentYear.value, month));
  const end = endOfMonth(start);
  const days = [];

  for (let date = start; date <= end; date = addDays(date, 1)) {
    days.push({ date: format(date, 'yyyy-MM-dd'), day: format(date, 'd') });
  }

  return days;
}

function isToday(dateStr: string) {
  return format(new Date(), 'yyyy-MM-dd') === dateStr;
}

function emitCreate(date: string) {
  if (props.onCreate) props.onCreate({ date });
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (month) => {
            return _createVNode(_component_v_col, {
              key: month,
              cols: "12",
              sm: "6",
              md: "3",
              class: "pa-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "text-subtitle-2" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(monthLabels[month - 1]), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getDaysForMonth(month - 1), (day) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: day.date,
                            class: "mb-1"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["text-caption font-weight-medium cursor-pointer", { 'text-primary': isToday(day.date) }]),
                              onClick: ($event: any) => (emitCreate(day.date))
                            }, [
                              _createTextVNode(_toDisplayString(day.day) + " ", 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getEventsForDate(day.date), (event) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  key: event.id,
                                  color: "primary",
                                  size: "x-small",
                                  class: "ml-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(event.name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ], 10, _hoisted_1)
                          ]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})